module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Shirt-c439065e329ad1ced084722f519fbcab66699f71602180fe46c6ef8ece316d53.svg";